import { z } from 'src/lib'
import { getEndpoint } from '.'
import { BaseResponse } from 'src/types'
import { OperacionWRCFields } from '../types/fields'
import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { DetallePutFields } from './detalle-fields'

const schema = z.object({
    [OperacionWRCFields.CodPais]: z.number(),
    [OperacionWRCFields.CodSectorComercial]: z.number(),
    [OperacionWRCFields.NroComitente]: z.string(),
    [OperacionWRCFields.DenominacionComitente]: z.string(),
    [OperacionWRCFields.Observaciones]: z.string().optional(),
    [OperacionWRCFields.FechaEmision]: z.date(),
    [OperacionWRCFields.FechaVencimiento]: z.date(),
    [OperacionWRCFields.BitEnvio]: z.boolean(),
    [OperacionWRCFields.Detalles]: z.array(
        z.object({
            [DetallePutFields.CodOperacionTipo]: z.number(),
            [DetallePutFields.Excepcion]: z.string()
        })
    )
})

export type OperacionWRC_Create = z.infer<typeof schema>

export const post = (operacion: OperacionWRC_Create): Promise<BaseResponse> => {
    const endpoint = getEndpoint()

    const parsed = schema.safeParse(operacion)

    if (!parsed.success) {
        console.error('Error de validación:', parsed.error.issues)

        return Promise.reject(new Error('Error de validación.'))
    }

    return HttpAxiosRequest.post(endpoint, parsed.data)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(error => {
            console.error('Error de red:', error)

            return Promise.reject('Error de red.')
        })
}
